export const FEATURES_ROUTING = {
  Partners: 'partners',
  Users: 'users',
  Services: 'services',
  LifeMoments: 'life-moments',
  CRM: 'crm',
  DevTools: 'dev-tools',
} as const;
